import { render, staticRenderFns } from "./CssSetup.vue?vue&type=template&id=50daa131&scoped=true&"
import script from "./CssSetup.vue?vue&type=script&lang=ts&"
export * from "./CssSetup.vue?vue&type=script&lang=ts&"
import style0 from "./CssSetup.vue?vue&type=style&index=0&id=50daa131&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50daa131",
  null
  
)

export default component.exports